import styled from 'styled-components';
import backgroundImage from '../../../../assets/images/dymin.webp';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  width: 100%;
  position: relative;
  overflow-x: hidden;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100vw;
  background-image: url(${backgroundImage});
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 70%;
  margin: 20px auto 70px auto;
  gap: 30px;

  @media (max-width: 840px) {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.9);
  width: 100%;
  padding: 30px 20px;

  @media (max-width: 840px) {
    padding: 25px 15px;
  }
`;

export const UpcommingTreksContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  border-bottom: 1px solid black;
  padding: 50px 0 70px;
`;

export const UpcomingTextBlock = styled.p<{ $spacing?: 'normal' | 'large' }>`
  font-weight: 300;
  line-height: 1.75em;
  letter-spacing: 0.05rem;
  text-align: center;
  width: 70%;
  margin: 0 0 ${({ $spacing }) => ($spacing === 'large' ? '44px' : '24px')} 0;

  @media (max-width: 840px) {
    width: 100%;
    padding: 0 15px;
    margin-bottom: ${({ $spacing }) => ($spacing === 'large' ? '36px' : '20px')};
  }
`;

export const UpcomingHighlight = styled.strong`
  font-weight: 600;
  color: #af9483;
`;

export const UpcomingCtaBox = styled.div`
  margin-top: 12px;
  padding: 26px 36px;
  background-color: #f8f6f2;
  border-radius: 8px;
  border-left: 3px solid #af9483;
  width: 70%;
  text-align: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  a {
    font-weight: 600;
    font-size: 1.1em;
    color: #1a1a1a;
    text-decoration: none;
    letter-spacing: 0.03rem;
    transition: color 0.2s ease;

    &:hover {
      color: #af9483;
    }
  }

  @media (max-width: 840px) {
    width: calc(100% - 30px);
    padding: 22px 20px;
  }
`;

export const Text = styled.p`
  font-weight: 300;
  line-height: 1.6em;
  letter-spacing: 0.05rem;
  text-align: center;
  width: 70%;
  margin: 0;
  @media (max-width: 840px) {
    width: 100%;
    padding: 0 15px;
  }
`;

export const TextSteps = styled.p`
  font-weight: 300;
  line-height: 1.7em;
  letter-spacing: 0.05rem;
  text-align: start;
  margin-top: 10px;
  @media (max-width: 840px) {
    width: 100%;
    padding: 0 15px;
  }
`;

export const TextBold = styled.p`
  font-weight: 800;
  font-size: 1.2em;
  line-height: 1.7em;
  letter-spacing: 0.05rem;
  text-align: center;
  width: 70%;
  margin-top: 10px;
  @media (max-width: 840px) {
    width: 100%;
    padding: 0 15px;
  }
`;

export const Title = styled.h1`
  font-weight: 900;
  font-size: 2em;
  line-height: 1.5em;
  letter-spacing: 0.1rem;
  margin: 0 15px 10px 15px;
  width: 70%;
`;

export const Subtitle = styled.h2`
  font-weight: 700;
  line-height: 1.5em;
  letter-spacing: 0.1rem;
  font-size: 1.6em;
  margin: 0 15px 30px 15px;
`;

export const TrekContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 70%;
  background-color: #f8f6f2;
  padding: 15px 20px;
  border-radius: 8px;
  margin: 8px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 840px) {
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }
`;

export const TrekContent = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px;
  gap: 15px;

  @media (max-width: 840px) {
    flex-direction: column;
    gap: 5px;
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  line-height: 1.5em;
  width: 70%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 15px 0;
  background-color: #f8f6f2;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 840px) {
    flex-direction: column;
    padding-top: 20px;
    width: 100%;
  }
`;

export const DescriptionBox = styled.div`
  width: 50%;
  margin: 20px;

  @media (max-width: 840px) {
    width: 100%;
    margin: 10px 20px;
  }
`;

export const Description = styled.div`
  padding: 5px 0 10px 0;
  font-size: 0.9em;
  line-height: 1.5em;
`;

export const DescriptionSmall = styled.div`
  padding: 10px 0;
  font-size: 0.8em;
  line-height: 1.5em;
  color: #666;
`;

export const ButtonStyled = styled.button`
  min-width: 180px;
  font-weight: 700;
  font-size: 0.85em;
  padding: 12px 16px;
  background-color: #1a1a1a;
  color: white;
  border: none;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: #af9483;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:focus {
    background-color: #af9483;
    outline: none;
  }

  &:disabled {
    background-color: #dad1c7;
    color: #faf6f1;
    box-shadow: none;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 840px) {
    margin-top: 10px;
    width: 100%;
  }
`;

export const StyledList = styled.ol`
  font-size: 1em;
  margin-left: 30px;
  background: none;
  background-color: none;
  width: 70%;
  @media (max-width: 840px) {
    margin-top: 10px;
    width: 80%;
  }
`;

export const StepsHorizontalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 15px;
  width: 100%;
  max-width: 1200px;
  margin: 30px auto;
  flex-wrap: nowrap;
  overflow-x: auto;

  @media (max-width: 768px) {
    gap: 10px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 15px;
    align-items: center;
    overflow-x: visible;
  }
`;

export const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 160px;
  min-width: 120px;
  flex: 1;

  @media (max-width: 768px) {
    max-width: 140px;
    min-width: 100px;
  }

  @media (max-width: 480px) {
    max-width: 300px;
    min-width: auto;
    width: 100%;
  }
`;

export const StepNumber = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #af9483;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.2em;
  margin-bottom: 15px;
`;

export const StepText = styled.p`
  font-size: 0.85em;
  line-height: 1.4em;
  color: #333;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.8em;
  }

  @media (max-width: 480px) {
    font-size: 0.9em;
    line-height: 1.5em;
  }
`;

export const ArrowIcon = styled.div`
  display: flex;
  align-items: center;
  color: #af9483;
  font-size: 1.5em;
  margin-top: 20px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 1.3em;
  }

  @media (max-width: 480px) {
    transform: rotate(90deg);
    margin: 10px 0;
  }
`;

export const StepWithArrow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 15px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    gap: 10px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    gap: 0;
  }
`;

export const EventInfoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 40px;
  width: 100%;
  padding: 20px;

  @media (max-width: 840px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const EventInfoColumn = styled.div`
  flex: 1;
  text-align: left;
`;

export const NoticeSection = styled.div`
  width: 70%;
  margin: 40px auto;
  padding: 35px 40px;
  background-color: #f8f6f2;
  border-radius: 8px;
  border-left: 3px solid #af9483;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

  @media (max-width: 840px) {
    width: 100%;
    padding: 25px 20px;
    margin: 30px 0;
  }
`;

export const NoticeTitle = styled.h3`
  font-weight: 600;
  font-size: 1.4em;
  margin-bottom: 20px;
  color: #1a1a1a;
  line-height: 1.4em;

  @media (max-width: 840px) {
    font-size: 1.3em;
  }
`;

export const NoticeSubtitle = styled.h4`
  font-weight: 500;
  font-size: 1.05em;
  margin: 20px 0 10px 0;
  color: #1a1a1a;
`;

export const NoticeText = styled.p`
  font-weight: 300;
  font-size: 0.95em;
  line-height: 1.3em;
  margin: 10px 0;
  color: #333;
  letter-spacing: 0.02rem;
`;

export const InfoSectionsContainer = styled.div`
  width: 70%;
  margin: 40px auto;
  padding: 40px 20px;

  @media (max-width: 840px) {
    width: 100%;
    padding: 30px 15px;
    margin: 30px 0;
  }
`;

export const InfoSection = styled.div`
  margin-bottom: 40px;
  text-align: left;

  @media (max-width: 840px) {
    margin-bottom: 30px;
  }
`;

export const SectionTitle = styled.h2`
  font-weight: 700;
  font-size: 1.4em;
  line-height: 1.5em;
  margin-bottom: 15px;
  color: #1a1a1a;

  @media (max-width: 840px) {
    font-size: 1.3em;
  }
`;

export const SectionText = styled.p`
  font-weight: 300;
  line-height: 1.7em;
  letter-spacing: 0.03rem;
  margin: 10px 0;
  color: #333;
`;

export const BulletList = styled.ul`
  margin-left: 20px;
  line-height: 1.7em;

  li {
    font-weight: 300;
    margin: 8px 0;
    color: #333;
  }
`;

export const ClosingSection = styled.div`
  text-align: center;
  font-style: italic;
  font-size: 1.1em;
  font-weight: 400;
  margin: 60px 0 40px 0;
  color: #1a1a1a;
  letter-spacing: 0.05rem;

  @media (max-width: 840px) {
    margin: 40px 0 30px 0;
    font-size: 1em;
  }
`;

export const ScrollButton = styled.button`
  display: block;
  margin: 40px auto;
  padding: 15px 30px;
  font-size: 1em;
  font-weight: 600;
  background-color: #af9483;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &:hover {
    background-color: #9d8270;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 840px) {
    width: 90%;
    padding: 14px 20px;
    font-size: 0.95em;
  }
`;

export const SimpleStepsContainer = styled.div`
  width: 70%;
  margin: 40px auto;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);

  @media (max-width: 840px) {
    width: 100%;
    padding: 25px 20px;
    margin: 30px 0;
  }
`;

export const StepsTitle = styled.h2`
  font-weight: 600;
  font-size: 1.5em;
  text-align: center;
  margin-bottom: 25px;
  color: #1a1a1a;

  @media (max-width: 840px) {
    font-size: 1.3em;
  }
`;

export const StepsList = styled.ol`
  margin: 0 auto;
  padding-left: 25px;
  max-width: 600px;

  li {
    font-weight: 300;
    font-size: 1em;
    line-height: 1.8em;
    margin: 12px 0;
    color: #333;
  }

  @media (max-width: 840px) {
    padding-left: 20px;

    li {
      font-size: 0.95em;
    }
  }
`;

export const StepsNote = styled.p`
  text-align: center;
  font-weight: 400;
  font-size: 0.95em;
  color: #666;
  margin-top: 25px;
  line-height: 1.6em;
`;
